import React from 'react'
import { useRouter } from '@scentregroup/shared/next/router'
import { getAbsolutePathFromRouter } from '@scentregroup/shared/helpers/url-helpers'

export const useStoresRoute = (): ((categories: string[]) => string) => {
  const router = useRouter()
  return React.useCallback(
    (categories: string[]) =>
      getAbsolutePathFromRouter(
        router,
        { categories, page: undefined },
        { categories }
      ),
    [router]
  )
}
